import * as constants from './Reset.constants';
import * as services from './Reset.service';

const state = {
  isRequest: false,
};

const mutations = {
  [constants.DUMMY_MUTATION]() {},

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async passwordResetValid({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const params = services.passwordResetValid(payload);
    await params;
    commit(constants.DUMMY_MUTATION, payload);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return params;
  },

  async passwordResetResetWithToken({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const params = services.passwordResetResetWithToken(payload);
    await params;
    commit(constants.DUMMY_MUTATION, payload);
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return params;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
